// extracted by mini-css-extract-plugin
export default {"filterLabel":"SourceCard_filterLabel__UDCws","subtitle":"SourceCard_subtitle__TvJ+Q","dateField":"SourceCard_dateField__rg8ZY"};